/** @format */

import React, { useState, useMemo, useCallback, useEffect } from "react";
import { Route, Routes, useNavigate, useMatch, Navigate } from "react-router-dom";
import { TabMenu } from "primereact/tabmenu";
import "../../style/news.css";
import Edit from "./Edit";
import SurveyReport from "./SurveyReport";
import SurveyLanding from "./SurveyLanding";

const Survey = (props) => {
  let navigate = useNavigate();
  let menuItems = useMemo(
    () => [
      {
        label: "Survey",
        command: () => navigate(""),
      },
      {
        label: "Survey Report",
        command: () => navigate("report"),
      },
    ],
    [navigate]
  );
  let summaryMatch = useMatch("/survey/report/summary/:id");
  let individualMatch = useMatch("/survey/report/individual/:id");
  let isSurveyReportMatch = useMatch("/survey/report");

  let [selectedMenuItem, setSelectedMenuItem] = useState(() =>
    summaryMatch?.pattern?.end || individualMatch?.pattern?.end || isSurveyReportMatch?.pattern?.end ? 1 : 0
  );
  useEffect(() => {
    setSelectedMenuItem(() =>
      summaryMatch?.pattern?.end || individualMatch?.pattern?.end || isSurveyReportMatch?.pattern?.end ? 1 : 0
    );
  }, [summaryMatch, individualMatch, setSelectedMenuItem, menuItems, isSurveyReportMatch]);
  const onTabChangeHandler = useCallback(
    (e) => {
      setSelectedMenuItem(e.index);
    },
    [setSelectedMenuItem]
  );

  return (
    <div className='main-box'>
      <div className='app__grid'>
        <TabMenu
          model={menuItems}
          activeIndex={selectedMenuItem}
          id='mi__tab__menu'
          className='mb-2'
          onTabChange={onTabChangeHandler}
        />
          <Routes>
            <Route index exact element={<SurveyLanding />} />
            <Route path='report/*' exact element={<SurveyReport />} />
            <Route path='edit/:id' exact element={<Edit />} />
            <Route path='*' element={<Navigate to='' replace />} />
          </Routes>
      </div>
    </div>
  );
};
export default Survey;
